import script from "./CompanyLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyLogo.vue?vue&type=script&setup=true&lang=js"

import "./CompanyLogo.vue?vue&type=style&index=0&id=bdd8b78a&scoped=true&lang=sass"

import exportComponent from "/Users/nika/Documents/Projects/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdd8b78a"]])

export default __exports__